import { Button } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import ArrowLeftIcon from '@/shared/assets/arrow-left-icon.svg?react';
import type { ComponentProps } from 'react';
import { cn } from '@/shared/utils';

type Props = ComponentProps<'button'> & {
  className?: string;
};

const OperationHistoryShowAllButton = ({ className, ...props }: Props) => {
  const { t } = useTranslation();
  return (
    <Button
      className={cn(
        'w-[18.4rem] h-[4.2rem] headline4 rounded-full bg-secondary-bg text-primary hover:bg-stroke-light-bg flex items-center justify-center gap-[0.8rem]',
        className
      )}
      {...props}>
      {t('personalAccount.lastOperationsSection.showAllButton')}
      <ArrowLeftIcon className="size-7 rotate-180" />
    </Button>
  );
};

export { OperationHistoryShowAllButton };
